import React, { useEffect, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { has, flatten } from 'lodash/fp';
import { Content } from 'rsuite';

const postMessage = (message = '', payload = null) => {
  window.top.postMessage(JSON.stringify({ message, payload }), '*');
};

const convertLineData = data =>
  data.map(({ x: lx, y: ly }, i) => {
    const { x: mx, y: my } = has(i + 1, data) ? data[i + 1] : { x: lx, y: ly };
    return { lx, ly, mx, my };
  });

export default () => {
  const canvasRef = useRef(null);
  const [canvasWidth, setCanvasWidth] = useState(300);

  useEffect(() => {
    setCanvasWidth(window.innerWidth);

    const messageHandler = ({ data: message }) => {
      if (message === 'clearSignature') canvasRef.current.clear();
    };
    window.addEventListener('message', messageHandler);
  }, []);

  const handleEnd = () => {
    const data = canvasRef.current.toData();
    const signatureData = JSON.stringify(flatten(data.map(convertLineData)));
    postMessage('updateSignatureData', signatureData);
  };

  return (
    <Content style={{ height: '100vh' }}>
      <SignatureCanvas
        ref={canvasRef}
        dotSize={1}
        minWidth={1}
        maxWidth={1}
        throttle={1}
        minDistance={1}
        velocityFilterWeight={0.2}
        canvasProps={{
          height: 245,
          width: canvasWidth,
          className: 'sigCanvas'
        }}
        onEnd={handleEnd}
      />
    </Content>
  );
};
